export default __webpack_public_path__ + "images/68df30433e87b6bb799d527cce0c53f3-sales_and_marketing_small.webp";